import {
  CommunitySummaryResultsDocument,
  CommunitySummaryResultsQuery,
  CommunitySummaryResultsQueryHookResult,
  CommunitySummaryResultsQueryVariables,
} from 'src/graphql';

import { CommunitySummaryResultsPartial } from 'src/graphql/subscriptions/communitySummaryResultsPartial';
import { TAsset } from 'src/typings/configuration.types';
import { parseSimulationResults } from 'src/utils/parseSimulationResults';
import { useMemo } from 'react';
import { useSubscribeToQuery } from 'src/hooks/useSubscribeToQuery';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useCommunitySummaryResults({
  communityUuid,
  jobId,
}: {
  communityUuid: TAsset['uuid'] | undefined;
  jobId?: string;
}) {
  const { data, loading, error } = useSubscribeToQuery<
    CommunitySummaryResultsQuery,
    CommunitySummaryResultsQueryVariables
  >({
    queryDoc: CommunitySummaryResultsDocument,
    subscriptionDoc: CommunitySummaryResultsPartial,
    variables: { jobId: jobId || '', communityUuid: communityUuid || '' },
    updateQuery(prev, { subscriptionData }) {
      const resultsPartial: NonNullable<
        CommunitySummaryResultsQueryHookResult['data']
      >['simulationResults'] = (subscriptionData?.data as any).simulationAreaResultsPartial[0];
      if (!resultsPartial) return prev;

      const next = Object.assign({}, prev, {
        simulationResults: {
          ...prev.simulationResults,
          ...resultsPartial,
        },
      });

      return next;
    },
  });

  return {
    data: useMemo(() => parseSimulationResults(data?.simulationResults), [data]),
    loading,
    error,
  };
}
